import { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const LayoutEmpty = () => import('../views/LayoutEmpty.vue')

const Details = () => import('../views/CompetitionRegionDetails.vue')
const DetailsInfo = () => import('../views/CompetitionRegionDetailsInfo.vue')
const DetailsStats = () => import('../views/CompetitionRegionDetailsStats.vue')

const ListAvailable = () => import('../views/CompetitionRegionListAvailable.vue')
const ListParticipated = () => import('../views/CompetitionRegionListParticipated.vue')
const List = () => import('../views/CompetitionRegionCards.vue')

const DetailsGroup = () => import('@/views/CompetitionRegionDetailsGroup.vue')
const DetailsVideos = () => import('@/views/CompetitionRegionDetailsVideos.vue')

const DrillDetailsInfo = () => import('../views/CompetitionRegionDrillDetailsInfo.vue')

const CompetitionAreaDetail = () => import('@/views/CompetitionAreaDetailsInfo.vue')
const CompetitionAreaDetailState = () => import('@/views/CompetitionAreaDetailsStats.vue')

export const drillDetailsInfoRoute: RouteConfig = {
  path: 'drill-info',
  name: 'competition_region_drill_details_info_teacher',
  component: DrillDetailsInfo,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '省市级比赛',
  },
}

export const detailsInfoRoute: RouteConfig = {
  path: 'info',
  name: 'competition_region_details_info',
  component: DetailsInfo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const detailsStatsRoute: RouteConfig = {
  path: 'stats',
  name: 'competition_region_details_stats',
  component: DetailsStats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const detailsGroupRoute: RouteConfig = {
  path: 'group',
  name: 'competition_region_details_group',
  component: DetailsGroup,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const detailsVideosRoute: RouteConfig = {
  path: 'videos',
  name: 'competition_region_details_videos',
  component: DetailsVideos,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const detailsRoute: RouteConfig = {
  path: 'details',
  name: 'competition_region_details',
  redirect: detailsInfoRoute,
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  children: [detailsInfoRoute, detailsStatsRoute, detailsGroupRoute, drillDetailsInfoRoute],
  meta: {
    title: '省市级比赛',
    [GlobalConfigRouteMetaEnum.Drills]: true,
    [GlobalConfigRouteMetaEnum.Homework]: true,
  },
}

export const areaDetailsInfoRoute: RouteConfig = {
  path: 'area_info',
  name: 'competition_area_details_info',
  component: DetailsInfo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const areaDetailsStatsRoute: RouteConfig = {
  path: 'area_stats',
  name: 'competition_area_details_stats',
  component: DetailsStats,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const listAvailableRoute: RouteConfig = {
  path: 'list-available',
  name: 'competition_region_list_available',
  component: ListAvailable,
  meta: {
    title: '省市级比赛',
  },
}

export const listParticipatedRoute: RouteConfig = {
  path: 'list-participated',
  name: 'competition_region_list_participated',
  component: ListParticipated,
  meta: {
    title: '省市级比赛',
  },
}

export const listRoute: RouteConfig = {
  path: 'list',
  name: 'competition_region_list',
  component: List,
  meta: {
    title: '省市级比赛',
    showMenu: true,
    messageTarget: 'region_match',
  },
}

export const areaDetailRoute: RouteConfig = {
  path: 'details',
  name: 'competition_area_detail',
  component: CompetitionAreaDetail,
  props: (route) => ({ ...route.query, ...route.params }),

  meta: {
    title: '省市级比赛',
  },
}

export const areaDetailStatRoute: RouteConfig = {
  path: 'details-stat',
  name: 'competition_area_detail_stat',
  component: CompetitionAreaDetailState,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '省市级比赛',
  },
}

export const detailsAreaRoute: RouteConfig = {
  path: 'area-details',
  name: 'competition_area_details',
  component: Details,
  redirect: areaDetailRoute,

  props: (route) => ({ ...route.query, ...route.params }),
  children: [areaDetailRoute, areaDetailsInfoRoute, areaDetailsStatsRoute],
  meta: {
    title: '省市级比赛',
  },
}

export default [
  {
    path: '/competition-region',
    name: 'competition_region',
    component: LayoutEmpty,
    redirect: listParticipatedRoute.name,

    children: [
      detailsRoute,
      detailsVideosRoute,
      detailsAreaRoute,
      areaDetailStatRoute,
      listAvailableRoute,
      listParticipatedRoute,
      listRoute,
    ],
  },
]

const listAvailableRouteClone: RouteConfig = {
  path: 'list-available',
  name: 'competition_region_list_available',
  component: ListAvailable,
  meta: {
    title: '省市级比赛',
  },
}

const listParticipatedRouteClone: RouteConfig = {
  path: 'list-participated',
  name: 'competition_region_list_participated',
  component: ListParticipated,
  meta: {
    title: '省市级比赛',
    showMenu: true,
  },
}

export const oldCompetitionRoutes = [
  {
    path: '/competition-region',
    name: 'competition_region',
    component: LayoutEmpty,
    redirect: listParticipatedRoute.name,

    children: [
      detailsRoute,
      detailsVideosRoute,
      detailsAreaRoute,
      areaDetailStatRoute,
      listAvailableRouteClone,
      listParticipatedRouteClone,
    ],
  },
]
